"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../core/collapse"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _input = _interopRequireDefault(require("../../core/input"));
var _button = _interopRequireDefault(require("../../core/button"));
var _submit = _interopRequireDefault(require("../../core/submit"));
var _alert = _interopRequireDefault(require("../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isOpened: false,
  saving: false,
  shouldValidate: false,
  newClub: {
    clubName: ''
  }
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Club Name");
class CreateClubForm extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleOpened", () => {
      this.setState(({
        isOpened
      }) => ({
        isOpened: !isOpened
      }));
    });
    _defineProperty(this, "_setValue", (value, name) => {
      this.setState({
        newClub: {
          ...this.state.newClub,
          [name]: value
        }
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      if (this._validate()) {
        this.setState({
          shouldValidate: true
        });
        return;
      }
      if (this._submitting) {
        return;
      }
      this._submitting = true;
      this.setState({
        saving: true,
        shouldValidate: true
      });
      this.props.onCreateClub(this.state.newClub).then(() => {
        this._submitting = false;
        this.setState(initialState);
      }, err => {
        this._submitting = false;
        this.setState({
          saving: false
        });
        throw err;
      });
    });
    _defineProperty(this, "_onCancel", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_validate", () => {
      const club = this.state.newClub;
      if (!club.clubName) {
        return 'You must provide a name for the club';
      }
    });
  }
  render() {
    const validationMessage = this.state.shouldValidate && this._validate();
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Club' : 'Add Club')), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, !validationMessage ? null : /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, validationMessage), /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "text",
      name: "clubName",
      value: this.state.newClub.clubName,
      onChange: this._setValue,
      required: true
    })))), /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.saving
    }, "Create Club"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancel
    }, "Cancel"))))));
  }
}
var _default = exports.default = CreateClubForm;